var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSystem = function SvgSystem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_11272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50005 2.63794V3.33794H5.80005V4.03794H5.10005V11.7379H14.9V11.0379H15.6V10.3379H16.3V3.33794H15.6V4.03794H14.9V4.73794H14.2V4.03794H14.9V3.33794H15.6V2.63794H6.50005ZM6.85005 5.78794H13.15V9.98794H6.85005V5.78794ZM17 10.3379V11.0379H16.3V11.7379H15.6V16.6379H16.3V15.9379H17V15.2379H17.7V10.3379H17ZM3.70005 12.4379V16.6379H14.9V12.4379H3.70005ZM9.30005 13.8379H13.5V14.5379H12.8V15.2379H12.1V14.5379H9.30005V13.8379ZM5.45005 14.5379H6.15005V15.2379H5.45005V14.5379ZM2.30005 17.3379V18.7379H14.2V18.0379H14.9V17.3379H2.30005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_11272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.687988)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSystem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/system.f9e3f6b0.svg";
export { ForwardRef as ReactComponent };